import ChevronIcon from '@src/assets/icons/chevron-down.svg';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from 'theme-ui';
import SingleQuestion from './SingleQuestion';
import './SurveyBox.scss';

type surveyStepProps = {
  questionIndex: number;
  question: any;
  register: any;
  surveyQuestion: number;
  setSurveyQuestion: any;
  setIsSurveyOpen: any;
  errors: any;
  isValid: boolean;
  surveyQuestionsLength: number;
  getValues: any;
  setValue: any;
  countryCodeInput: any;
  setCountryCodeInput: any;
  sendPartialSurveyData: any;
};

function SurveyFormStep({
  questionIndex,
  question,
  register,
  surveyQuestion,
  setSurveyQuestion,
  setIsSurveyOpen,
  errors,
  isValid,
  surveyQuestionsLength,
  getValues,
  setValue,
  countryCodeInput,
  setCountryCodeInput,
  sendPartialSurveyData,
}: surveyStepProps) {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState('');

  const goBack = () => {
    setErrorMessage('');
    setSurveyQuestion(surveyQuestion - 1);
  };

  return (
    <Box
      key={questionIndex}
      style={{
        display: questionIndex === surveyQuestion ? 'flex' : 'none',
        height: '100%',
        flexDirection: 'column',
      }}
    >
      <div
        onClick={goBack}
        className="survey-back-button"
        style={{ display: surveyQuestion === 0 ? 'none' : 'flex' }}
      >
        <ChevronIcon />
      </div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
        }}
      >
        {Array.isArray(question.question) ? (
          <div style={{ height: '100%' }}>
            {question.question?.map((arrayQuestion, arrayIndex) => (
              <SingleQuestion
                key={arrayIndex}
                question={arrayQuestion}
                questionIndex={arrayIndex}
                surveyQuestion={surveyQuestion}
                register={register}
                setSurveyQuestion={setSurveyQuestion}
                setIsSurveyOpen={setIsSurveyOpen}
                errors={errors}
                surveyQuestionsLength={surveyQuestionsLength}
                setValue={setValue}
                countryCodeInput={countryCodeInput}
                setCountryCodeInput={setCountryCodeInput}
                getValues={getValues}
              />
            ))}
          </div>
        ) : (
          <SingleQuestion
            question={question}
            questionIndex={questionIndex}
            surveyQuestion={surveyQuestion}
            register={register}
            setSurveyQuestion={setSurveyQuestion}
            setIsSurveyOpen={setIsSurveyOpen}
            errors={errors}
            surveyQuestionsLength={surveyQuestionsLength}
            setValue={setValue}
            countryCodeInput={countryCodeInput}
            setCountryCodeInput={setCountryCodeInput}
            getValues={getValues}
          />
        )}
        {question.answersType === 'input' &&
          questionIndex !== surveyQuestionsLength && (
            <div
              className="smaller-font-size"
              style={{
                width: '100%',
                paddingTop: '20px',
              }}
            >
              <Button
                className="smaller-font-size"
                onClick={(e) => {
                  e.preventDefault();
                  setSurveyQuestion(surveyQuestion + 1);
                  sendPartialSurveyData();
                }}
                disabled={
                  !question.options
                    ?.filter((option) => option.required)
                    .every(
                      (requiredOption) => getValues()[requiredOption.title]
                    )
                }
                sx={{
                  padding: '10px 30px',
                  fontFamily: 'Roboto, sans-serif',
                }}
              >
                {t('survey.continue')}
              </Button>
            </div>
          )}
        {questionIndex === surveyQuestionsLength - 1 && (
          <div
            className="smaller-font-size"
            style={{
              width: '100%',
              paddingTop: '20px',
            }}
          >
            <Button
              className="smaller-font-size"
              type="submit"
              disabled={!isValid}
              sx={{
                padding: '10px 30px',
                fontFamily: 'Roboto, sans-serif',
              }}
            >
              {t('survey.finish')}
            </Button>
            <div sx={{ color: 'error' }}>{errorMessage}</div>
          </div>
        )}
      </Box>
    </Box>
  );
}

export default SurveyFormStep;
